import { defineStore } from 'pinia'
import { GarbanzoConfig } from '~/types/globals/Garbanzo'

interface ConfigState {
  config: GarbanzoConfig,
}

export const useConfigStore = defineStore('config', {
  state: (): ConfigState => ({
    config: {} as GarbanzoConfig,
  }),
  actions: {
    setConfig(config: GarbanzoConfig) {
      this.config = config
    },
  },
})
